module.exports = __webpack_public_path__ + "img/zejiang.97add396.png";